import {property} from "lit/decorators/property.js";
import {AbstractLitElement} from "./abstract-lit.element";

export class AbstractRoutableLitElement extends AbstractLitElement {

    protected _location: any | null = null;

    @property()
    public get location(): any | null {
        return this._location;
    }

    public set location(value: any | null) {
        if (!value) {
            return;
        }

        const oldValue = this._location;
        this._location = value;

        for (const [propertyName, propertyValue] of Object.entries(this._location.params)) {
            if (this.hasAttribute(propertyName)) {
                this.setAttribute(propertyName, Array.isArray(propertyValue) ? JSON.stringify(propertyValue) : propertyValue!.toString());
            }
        }

        this.requestUpdate(`location`, oldValue);
    }

}